<template>
<div>
	<Form :label-width="110" @submit.native.prevent>
		<Row :gutter="10">
			<Col span="8">
				<FormItem label="参保公司">
					<Input v-model="params.companyName" clearable @on-enter="search" placeholder="参保公司名称"></Input>
				</FormItem>
			</Col>
			<Col span="16" class="right">
				<Button type="info" @click="search">搜索</Button>
				<Button type="primary" @click="excel">导出</Button>
			</Col>
		</Row>
	</Form>
	<i-table :columns="columns" url="/trainee/queryCompany" :params="params" ref="table" >
		<template slot-scope="{ row, index }" slot="organizationUrl">
			<a :href="row.organizationUrl" target="_blank" v-if="row.organizationUrl">查看</a>
		</template>
		<template slot-scope="{ row, index }" slot="address">
			{{row.provinceName}}{{row.cityName}}{{row.areaName}}{{row.address}}
		</template>
		<template slot-scope="{ row, index }" slot="action">
			<a @click="openEdit(row)">编辑</a>
		</template>
	</i-table>
	<Modal v-model="editShow" title="编辑公司信息" :mask-closable="false" >
		<Form :label-width="110" v-if="editShow" :model="editForm" :rules="editFormRules" ref="editForm">
			<Form-item label="公司名称">
				<Input v-model="editForm.companyName" clearable placeholder="公司名称"></Input>
			</Form-item>
			<Form-item label="统一社会信用代码" prop="organizationCode">
				<Input v-model="editForm.organizationCode" clearable :maxlength="18" @on-change="resetUpperCaseValue"></Input>
			</Form-item>
			<Form-item label="通讯地址" prop="areaCode">
				<Area v-model="editForm.areaCode" placeholder="请选择省市区" @get-city-str="areaChange"></Area>
			</Form-item>
			<Form-item prop="address">
				<Input v-model="editForm.address" clearable placeholder="详细地址"></Input>
			</Form-item>
			<Form-item label="营业执照" prop="organizationUrl" >
				<UploadFileImg @on-success="editBindUploadSuccess" type="select" btn-text="上传"/> 
				<a @click="openOriginFile(editForm.organizationUrl)" v-show="editForm.organizationUrl" class="ml20">查看</a>
			</Form-item>
		</Form>
		<div slot="footer" style="text-align: center">
			<Button @click="cancelEdit" type="default">取消</Button>
			<Button @click="confirmEdit" type="primary">确定</Button>
		</div>
	</Modal>
</div>
</template>

<script>
import ITable from '@/components/common/ITable'
import UploadFileImg from '@/components/common/UploadFileImg'
import Area from '@/pages/haierProduct/components/common/Area'

export default {
	components:{ITable,UploadFileImg,Area},
	data () {
		return {
			params:{},
			columns:[
				{title: '公司名称',key: 'companyName',minWidth:200},
				{title: '统一社会信用代码',key: 'organizationCode',minWidth:200},
				{title: '通讯地址',slot: 'address',minWidth:200},
				{title: '联系人',key: 'name',width:100},
				{title: '手机号',key: 'phone',width:130},
				{title: '邮箱',key: 'email',width:180},
				{title: '营业执照',slot: 'organizationUrl',width:100},
				{title: '操作',slot: 'action',width:80,fixed:'right'},
			],
			total:'',
			editForm:{},
			editFormRules:{
				organizationCode:[{required:true,message:'请输统一社会信用代码',trigger:'blur'},{message:'格式错误',trigger:'blur',pattern:this.rules.organizationCode}],
				areaCode:{required:true,message:'请选择地区',trigger:'change'},
				address:{required:true,message:'请输入详细地址',trigger:'blur'},
				organizationUrl:{required:true,message:'请上传营业执照',trigger:'change'},
			},
			editShow:false
		}
	},
	created () {
	},
	methods: {
		search () {
			this.$refs.table.getList();
		},
		excel () {
			this.exportToExcel("/trainee/exportCompany",this.params);
		},
		// 选择省市区
		areaChange(val){
			console.log(val)
			this.editForm.provinceCode=val[0].value
			this.editForm.provinceName=val[0].label
			this.editForm.cityCode=val[1].value
			this.editForm.cityName=val[1].label
			this.editForm.areaName=val[2].label
		},
		// 导入参保公司
		toImport(){
			this.$router.push('/haier/trainee/company-import')
		},
		// 编辑绑定人员上传附件成功
		editBindUploadSuccess(val) {
			this.$set(this.editForm,'organizationUrl',val.url)
		},
		// 打开编辑人员
		openEdit(row){
			this.editShow=true;
			this.$nextTick(()=>{
				this.editForm= this.jsonCopy(row)
			})
		},
		// 确定编辑人员
		confirmEdit(){
			this.$refs.editForm.validate((valid) => {
				if (valid) {
					this.$axios.post('/trainee/editCompany',this.editForm).then(res=>{
						this.toast('编辑成功')
						this.search()
						this.cancelEdit()
					});
				}
			})
		},
		// 关闭
		cancelEdit(){
			this.editShow = false;
			this.$refs.editForm.resetFields();
		},
		// 小写转大写
		resetUpperCaseValue(event){
			if(event.target.value){
				this.editForm.organizationCode=event.target.value.toUpperCase();
			}
		}

	}
}
</script>


// WEBPACK FOOTER //
// src/pages/haierProduct/components/traineeEmployer/list/Company.vue